//ManageContractList

import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { ContractService } from "../../../services";

import Editor from "react-simple-wysiwyg";

import {  
  handleConsoleError,
} from "../../../utils/common-methods";

function Contract(props) {
  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");
  const [id, setId] = useState("");

  const [name, setName] = useState("");
  const [contractDtl, setContractdetails] = useState("");
  const [contractFor, setContractFor] = useState("");

  const [isactive, setIsActive] = useState(false);
  //const [isSignRequire, setIsSignRequire] = useState(false);
   const isSignRequire = false;
  const [currentPage, setCurrentPage] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  const tags =[
    "#Eventname",
    "#EventStartDate",
    "#EventEndDate",
    "#EventStartTime",
    "#EventEndTime",
    "#EventPostCode",
    "#EventCountry",
    "#EventState",
    "#EventAddress",
    "#EventStartDay",
    "#EventEndDay",
    "#EventStartDayPreviousDay",
    "#EventEndDayNextDay",
    "#BusinessName",
    "#LeagalBusinessName",
    "#EventContactName",
    "#EventContactPhone",
    "#EventCOntactEmail",
    "#EventStartDatePreviousdate",
    "#EventEndDateNextDate",
    "#EventYear",
    "#BusinessRegistrationNumber",
    "#VatNumber",
  ];

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  // Contract List API
  const getData = async () => {
    props.application.setLoading(true);
    try {
      const res = await ContractService.getContractList();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleName = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val.trim() === "") {
      setError("Name is required");
    } else {
      setError("");
    }
    setName(val);
  };

  const handleDescription = (e) => {
    const val = e.target.value;

    if (val?.trim() === "<br>") {
      setError("Contract Detailsis required");
    } else {
      setError("");
    }
    setContractdetails(val);
  };

  const handleContractFor = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("contractFor is required");
    } else {
      setError("");
    }
    setContractFor(val);
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (name?.trim() === "") {
      setError("Name is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    if (contractDtl?.trim() === "<br>") {
      setError("Contract Detailsis required");
      valid = false;
      return;
    } else {
      setError("");
    }

    if (contractFor?.trim() === "<br>") {
      setError("contractFor is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    if (!valid) {
      setError("Please fill all fields");
      return;
    } else {
      setError("  ");
      try {
        props.application.setLoading(true);

        const data = {
          name: name?.trim(),
          contractDtl: contractDtl?.trim(),
          contractFor: contractFor,
          isactive: isactive,
          isSignRequire: isSignRequire,
          id: id,
        };
        const res = await ContractService.updateContract(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          toast.success(res?.message);
        } else {
          toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          props.application.setLoading(false);
        }
        // }
        handleClose();
        setId("");
        getData();
      } catch (err) {
        props.application.setLoading(false);
        const message = handleConsoleError(err);
        toast.error(err?.message || message);
        setId("");
      }
    }
  };

  const handleEdit = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await ContractService.getContractById(id);

      if (res?.isSuccess) {
        setName(res?.data?.name);
        setContractdetails(res?.data?.contractDtl);
        setContractFor(res?.data?.contractFor);
        setIsActive(res?.data?.isActive);
        setId(id);
        handleShow();
        props.application.setLoading(false);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);

    if (filteredData.length === 0) {
      setShowNextButton(false);
    } else if (selected === pageCount - 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={showPreviousButton ? "Previous" : null}
          nextLabel={showNextButton ? "Next" : null}
          breakLabel="..."
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  //  Drag And Drop Functionlity
  const handleDragStart = (e, tag) => {
    e.dataTransfer.setData("text/plain", tag);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const tag = e.dataTransfer.getData("text/plain");
    setContractdetails((prev) => prev + ` ${tag} `);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">Contract</li>
          </ol>
        </nav>
      </div>

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        className="custom-contract-modal"
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>{id === "" ? "Add" : "Update"} Contract</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="searchformfld">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Name"
                value={name}
                maxLength="100"
                onChange={handleName}
                required
                disabled
              />
              {/* <label>
                Contract Details<span className="text-danger">*</span>
              </label>
              <Editor value={contractDtl} onChange={handleDescription} /> */}

              <label>
                Contract Details<span className="text-danger">*</span>
              </label>
              <div
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  minHeight: "150px",
                  overflowX: "scroll",
                  maxHeight: "330px",
                }}
              >
                <Editor value={contractDtl} onChange={handleDescription} />
              </div>

              <label className="mt-3">
                Contract For <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Contract For"
                value={contractFor}
                maxLength="10"
                onChange={handleContractFor}
                required
                disabled
              />

              <div className="custom-check" style={{ marginTop: "10px" }}>
                <label>Status </label>
                <input
                  type="checkbox"
                  checked={isactive} // Controlled by state
                  onChange={handleIsActive} // Handle change event
                />
              </div>

              {/* Tags Section */}
              <div
                className="tags-section mt-3"
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                <div className="tags-container">
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="tag-item"
                      draggable
                      onDragStart={(e) => handleDragStart(e, tag)}
                      style={{
                        padding: "5px 10px",
                        margin: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        cursor: "grab",
                        display: "inline-block",
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            {error && <span className="text-danger">{error}</span>}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleSubmit}
          >
            {id === "" ? "Save" : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="table-responsive">
        <div>
          <h2>Contract</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              {/* <th>Contract Details</th> */}
              <th>Contract For</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.name}</td>
                      {/* <td>
                      
                        {item.contractDtl}
                      </td> */}

                      <td>
                        {item?.contractFor === "C"
                          ? "Caterers"
                          : item?.contractFor === "R"
                          ? "Retail Trade Stands"
                          : "-"}
                      </td>

                      <td className="delete-create">
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>

                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item?.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>

                          {/*isDataLength === false ?  "":  */}
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              //handleDelete(item._id);
                            }}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </Link> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <strong>Total Count: {filteredData.length}</strong>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(Contract);
